// ----------------------------------------------------------------------
// <copyright file="Izenda.Resizer.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
// </copyright>
// ----------------------------------------------------------------------
!(function() {
  var React = require('react');
  var PropTypes = React.PropTypes;
  var ResizableController = require('./Izenda.ResizableController');
  var Resizable = require('./Izenda.Resizable');

  var observer = require('mobx-react').observer;
  var Resizer = React.createClass({
    propTypes: {
      children: PropTypes.element.isRequired,
      width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      onResize: PropTypes.func,
      onResizeStop: PropTypes.func,
      minConstraints: PropTypes.arrayOf(PropTypes.number),
      maxConstraints: PropTypes.arrayOf(PropTypes.number),
      rightResize: React.PropTypes.bool,
      bottomResize: React.PropTypes.bool,
      bottomRightResize: React.PropTypes.bool,
      rightResizeClass: React.PropTypes.string,
      bottomResizeClass: React.PropTypes.string,
      bottomRightResizeClass: React.PropTypes.string
    },
    getDefaultProps: function() {
      return {
        width: 'auto',
        height: 'auto',
        rightResize: false,
        bottomResize: false,
        bottomRightResize: false
      };
    },
    componentWillMount: function() {
      var props = this.props;
      // Initial component variables
      this.controller = new ResizableController(
        0,
        0,
        props.width,
        props.height,
        props.minConstraints,
        props.maxConstraints
      );
    },
    componentWillReceiveProps: function(nextProps) {
      if (nextProps.width !== this.props.width || nextProps.height !== this.props.height) {
        this.controller.setWidthHeight(nextProps.width, nextProps.height);
      }
    },
    render: function() {
      var props = this.props;
      var minConstraints = props.minConstraints;
      var maxConstraints = props.maxConstraints;
      var rightResize = props.rightResize;
      var bottomResize = props.bottomResize;
      var bottomRightResize = props.bottomRightResize;
      var rightResizeClass = props.rightResizeClass;
      var bottomResizeClass = props.bottomResizeClass;
      var bottomRightResizeClass = props.bottomRightResizeClass;
      var onResize = props.onResize;
      var onResizeStop = props.onResizeStop;

      var style = {
        width: this.controller.width,
        height: this.controller.height
      };

      return (
        <Resizable
          width={this.controller.width}
          height={this.controller.height}
          minConstraints={minConstraints}
          maxConstraints={maxConstraints}
          rightResize={rightResize}
          bottomResize={bottomResize}
          bottomRightResize={bottomRightResize}
          rightResizeClass={rightResizeClass}
          bottomResizeClass={bottomResizeClass}
          bottomRightResizeClass={bottomRightResizeClass}
          resizableController={this.controller}
          style={style}
          onResize={onResize}
          onResizeStop={onResizeStop}
        >
          {this.props.children}
        </Resizable>
      );
    }
  });

  module.exports = observer(Resizer);
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.Resizer.jsx